import { store } from './store.js';
/**
 * SUMMARY MANAGER - Detectimáticas de 1º
 * Gestión de la pantalla final de resultados y estadísticas de la sesión.
 */

const SummaryManager = {
    init() {
        console.log('🏆 Inicializando SummaryManager...');
    },

    render() {
        const state = store.state;
        if (!state) return;

        // Mark end time if not already marked
        if (!state.endTime) state.endTime = Date.now();

        // Update score display
        const scoreValueEl = document.getElementById('scoreValue');
        if (scoreValueEl) scoreValueEl.textContent = state.score;

        // Update message based on score
        const summaryMessage = document.getElementById('summaryMessage');
        if (summaryMessage && window.speak) {
            let message = '';
            let sound = 'playError';

            const maxScore = state.problems ? state.problems.length : 5;
            const isPerfect = state.score === maxScore;
            const isGood = state.score >= Math.floor(maxScore / 2);

            if (store.config && store.config.context === 'cumpleanos' && store.config.problemType === 'any') {
                if (isPerfect) {
                    message = '¡Increíble! Gracias a ti, la fiesta de cumpleaños ha sido perfecta y todos los problemas se han solucionado.';
                    sound = 'playConfetti';
                } else {
                    message = `¡Muy buen trabajo en la fiesta! Resolviste ${state.score} misterios y todos se lo pasaron genial.`;
                    sound = isGood ? 'playSuccess' : 'playError';
                }
            } else {
                if (isPerfect) {
                    message = '¡Perfecto! Eres un verdadero Detective Matemático.';
                    sound = 'playConfetti';
                } else if (isGood) {
                    message = '¡Muy bien! Sigue practicando.';
                    sound = 'playSuccess';
                } else {
                    message = '¡Buen intento! La práctica hace al maestro.';
                    sound = 'playError';
                }
            }

            summaryMessage.textContent = message;
            if (window.speak) window.speak(message, window.currentLanguage || 'es-ES');
            if (window.SoundService && window.SoundService[sound]) window.SoundService[sound]();
        }

        this.setupEventListeners();
        console.log(`🏆 Resumen mostrado. Puntuación: ${state.score}/${state.problems ? state.problems.length : 5}`);
    },

    setupEventListeners() {
        const newSessionBtn = document.getElementById('newSessionBtn');
        if (newSessionBtn) {
            newSessionBtn.onclick = () => {
                if (window.showConfigScreen) window.showConfigScreen();
            };
        }

        const backToWelcomeBtn = document.getElementById('backToWelcomeFromSummaryBtn');
        if (backToWelcomeBtn) {
            backToWelcomeBtn.onclick = () => {
                if (window.showWelcomeScreen) window.showWelcomeScreen();
            };
        }
    }
};

// Aliases
window.renderSummary = () => SummaryManager.render();
